import Icon from '@ant-design/icons'
import {documentModel} from 'apis/model'
import DefaultLayout from 'components/layouts/Default'
import ContentLayout, {PageHeader,} from 'components/layouts/Default/ContentLayout'
import {LoginContext} from 'components/LoginContext'
import Pure from 'components/Pure'
import {createLazyComponent} from 'helpers/createLazyComponent'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import {useLocation} from 'react-use'
import {fromRenderProps, mapProps, nest, pure, withProps,} from 'recompose'
import {compose} from 'redux'
import CreateNewArticle from 'views/Articles/CreateNewArticle.lazy'
import {gConfigs, gPaths} from 'views/AppLocals/configs'
import MainPage from 'views/MainPage'
import Menu from 'views/Menu'
import Messages from 'views/Messages/Messages.lazy'
import CRUD from 'views/Shared/enums/CRUD'
import withTranslate from '../modules/local/withTranslate'
import MyActivities from '../views/MainPage/MyActivities.lazy'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import RedirectPage from '../views/RedirectPage'
import {
    createRequiredLogin,
    ModalForgetPassword,
    ModalLogin,
    ModalSignUp,
    NotRequiredLoginModal,
} from './createRequiredLogin'
import {createRequiredNonLogin} from './createRequiredNonLogin'
import {REQUIRED_LOGIN, REQUIRED_NON_LOGIN} from './routesValidate'
import {staticPaths} from './staticPaths'

import Profile from "../views/AppLocals/Profile/Profile.lazy";
import {NullAsDefault} from "../views/Shared";
import ChurchSearchView from "../views/AppLocals/Church/containers/ChurchMassTimeSearchView.lazy";
import MassTimesPage from "../views/AppLocals/Church/containers/MassTimesPage.lazy";
import GamesPage from "../views/AppLocals/Game/containers/GamesPage.lazy";
import BiblePage from "../views/AppLocals/Codi/containers/BiblePage.lazy";
import ReligiousOrderPage from "../views/AppLocals/ReligiousOrder/containers/ReligiousOrderPage.lazy";
import ProfilePage from "../views/AppLocals/Profile/containers/ProfilePage.lazy";
import OrganizationPage from "../views/AppLocals/Organization/containers/OrganizationPage.lazy";
// EducationLandingPage — trang mới "Kristo Edu" tại /edu (route key nội bộ vẫn giữ "courses", xem
// staticPaths.js), làm song song với CoursePage cũ (không xoá) để còn tham chiếu; dọn dẹp (bỏ
// import CoursePage) ở bước sau khi chốt xong layout.
import EducationPage from "../views/AppLocals/Course/containers/EducationLandingPage.lazy";
import MusicPage from "../views/AppLocals/Music/containers/MusicPage.lazy";
import SongsPage from "../views/AppLocals/Music/containers/SongsPage.lazy";
import DefinitionPage from "../views/AppLocals/Dictionary/containers/DefinitionPage.lazy";
import DefinitionSinglePage from "../views/AppLocals/Dictionary/containers/DefinitionSinglePage.lazy";
import DictionarySinglePage from "../views/AppLocals/Dictionary/containers/DictionarySinglePage.lazy";
import EcclesiasticPage from "../views/AppLocals/EcclesiasticDocument/containers/EcclesiasticPage.lazy";
import DocumentsPage from "../views/AppLocals/DocumentLibrary/containers/DocumentsPage.lazy";
import CatholicHouseholdPage from "../views/AppLocals/CatholicHousehold/containers/CatholicHousegoldPage.lazy";
import AccessPortalPage from "../views/Workspace/AccessPortal/AccessPortalPage.lazy";
import LiturgiesPage from "../views/AppLocals/Liturgies/containers/LiturgiesPage.lazy";
import TurnToChristPage from "../views/MainPage/TurnToChristPage.lazy";
import EvangelizationPage from "../views/MainPage/EvangelizationPage.lazy";
import MissalPage from "../views/AppLocals/Missal/MissalPage.lazy";
import MissalPageEditor from "../views/AppLocals/Missal/MissalPageEditor.lazy";
import {Channel} from 'views/Channel';
import {Bookmark} from 'views/Bookmark';
import {FullSideModalLayout} from 'components/Modal/SideModalLayout';
import {HeaderButton} from 'views/Organization/components/PageHeader';
import Notification from 'views/Notification';
import Music from 'views/AppLocals/Music';
import LandingPage from 'views/LandingPage';
import Category from 'views/Category';
import ChannelSetting from 'views/ChannelSetting';
import CreatePoll from 'views/CreatePoll';
import DiscoveryPage from 'views/AppLocals/Directory/containers/DiscoveryPage';
import DocumentEditor from 'views/DocumentEditor';
import Feed from 'views/Feed';
import Invite from 'views/Invite';
import InviteOrganization from 'views/InviteOrganization';
import Codi from 'views/AppLocals/Codi';
import WoG from 'views/AppLocals/WoG';
import CatholicHousehold from 'views/AppLocals/CatholicHousehold';
import FamilyBooks from 'views/AppLocals/FamilyBook';
import FamilyBookDetail from 'views/AppLocals/FamilyBook/FamilyBookDetail.lazy';
import {ForgetPassword, Login, Logout, ResetPassword} from 'views/Auth';
import Account from 'views/Account';
import AccountSettings from 'views/Account/AccountSettings';
import SelectCategory from 'views/SelectCategory';
import Missal from "../views/AppLocals/Missal";
import MissalV2 from "../views/AppLocals/Missal/v2";
import ActivateAccountForm from "../views/Auth/ActivateAccountForm";
import {MdClose} from "react-icons/md";
import PilgrimagePage from "../views/AppLocals/Pilgrimage/containers/PilgrimagePage.lazy";
import CourseClassExamPage from "../views/AppLocals/Course/Exam/CourseClassExamPage.lazy";
import CourseClassExamAttempt from "../views/AppLocals/Course/Exam/CourseClassExamAttempt.lazy";
import ProductsPage from "../views/AppLocals/Shop/containers/ProductLandingPage.lazy";
import PrayerLandingPage from "../views/AppLocals/Prayer/containers/PrayerLandingPage.lazy";
import PrayerBooksLandingPage from "../views/AppLocals/Liturgies/containers/PrayerBooksLandingPage.lazy";
import PrayerBookDetailPage from "../views/AppLocals/Devotion/containers/PrayerBookDetailPage.lazy";
import SpaceOrganization from "../views/MainPage/Space/SpaceOrganization.lazy";
import SpaceWebApps from "../views/MainPage/Space/SpaceWebApps.lazy";
import DioceseParishesPage from "../views/AppLocals/Diocese/containers/DioceseLandingPage.lazy";
import ExaminationPage from "../views/AppLocals/Examination/containers/ExaminationPage.lazy";
import CatholicNewsPage from "../views/AppLocals/ChannelArticle/containers/CatholicNewsPage.lazy";
import SpiritualityPage from "../views/AppLocals/Spirituality/containers/SpiritualityPage.lazy";
import DiaryEntry from "../views/AppLocals/Examen/DiaryEntry.lazy";
import Examen from "../views/AppLocals/Examen/Examen.lazy";
import Discernment from "../views/AppLocals/Discernment/Discernment.lazy";
import Retreat from "../views/AppLocals/Retreat/Retreat.lazy";
import Devotion from "../views/AppLocals/Devotion/Devotion.lazy";
import DevotionDetail from "../views/AppLocals/Devotion/DevotionDetail.lazy";
import PrayerMethod from "../views/Prayer/PrayerMethod.lazy";
import PrayerMethodDetail from "../views/Prayer/PrayerMethodDetail.lazy";

const CreateEventFormModal = createLazyComponent(() =>
    import('../views/Event/Events').then(m => ({default: m.CreateEventFormModal}))
)
const CreateChannelFormModal = createLazyComponent(() =>
    import('../views/Organization/components/Channels').then(m => ({default: m.CreateChannelFormModal}))
)
const NoFoundPage = createLazyComponent(() => import('views/NoFoundPage'));
const EnhancedQuickLink = createLazyComponent(() => import('views/QuickLink/EnhancedQuickLink'));
const EnhancedQuickLinkSetting = createLazyComponent(() => import('views/QuickLinkSetting/EnhancedQuickLinkSetting'));
const MyBookmarks = createLazyComponent(() => import('views/MainPage/MySpace/MyBookmarks'));
const CalendarPage = createLazyComponent(() => import('views/AppLocals/Codi/CalendarPage'));
const LiturgicalCalendarPage = createLazyComponent(() => import('views/AppLocals/Codi/LiturgicalCalendar/LiturgicalCalendarPage'));
const LiturgicalPage = createLazyComponent(() => import('views/AppLocals/Codi/LiturgicalPage'));
const Modal = createLazyComponent(() => import('components/Modal/Modal'));
const ServerContainer = createLazyComponent(() => import('views/Server/ServerContainer'));
const DocumentPost = createLazyComponent(() => import('../views/Document/DocumentPost'));
const AskPage = createLazyComponent(() => import("../views/Asks/containers/AskPage"));
const DiscussionsPage = createLazyComponent(() => import("../views/Discussions/containers/DiscussionsPage"));
const Feedbacks = createLazyComponent(() => import("../views/AppLocals/Feedback/containers/Feedbacks"));
const FeedbackRequests = createLazyComponent(() => import("../views/AppLocals/Feedback/containers/FeedbackRequests"));
const YellowPages = createLazyComponent(() => import("../views/AppLocals/YellowPage/containers/YellowPages"));
const Missals = createLazyComponent(() => import("../views/AppLocals/Missal/containers/Missals"));
const ChurchDetail = createLazyComponent(() => import("../views/AppLocals/Church/containers/ChurchDetail"));

const Topic = createLazyComponent(() => import('../views/Topic/Topic'));
const Search = createLazyComponent(() => import('../views/Search/Search'));
const Navigation = createLazyComponent(() => import('../views/Navigation/Navigation'));
const PageDetail = createLazyComponent(() => import('../views/User/PageDetail'));
const FeedSetting = createLazyComponent(() => import('../views/Feed/FeedSetting'));
const Exam = createLazyComponent(() => import('../views/AppLocals/Exam'));


export const routesConfig = [
    {
        path: '/auth/verify/:activation_reset_code',
        name: 'activate',
        component: ActivateAccountForm,
    },
    {
        key: 'reset-pwd',
        name: 'reset password',
        path: '/auth/reset-pwd',
        exact: true,
        component: ResetPassword,
    },
    {
        path: '/invite/:id',
        name: 'invite',
        component: Invite,
        exact: true,
    },
    {
        path: '/invite/organization/:id',
        name: 'invite',
        component: InviteOrganization,
        exact: true,
    },
    {
        key: 'select_category',
        name: 'select-category',
        path: '/select-category',
        exact: true,
        component: () => {
            return (
                <Translate>
                    {(t) => (
                        <NavigationContext.Consumer>
                            {({handleGoBack}) => {
                                return (
                                    <FullSideModalLayout
                                        title={t('categories')}
                                        // center
                                        onCancel={handleGoBack}>
                                        <SelectCategory onSuccess={handleGoBack}/>
                                    </FullSideModalLayout>
                                )
                            }}
                        </NavigationContext.Consumer>
                    )}
                </Translate>
            )
        },
        meta: {
            validate: [REQUIRED_LOGIN],
        },
    },
    {
        path: '/messages',
        name: 'messages',
        exact: true,
        component: createRequiredLogin(ModalLogin)(nest(DefaultLayout, Messages)),
    },
    {
        path: '/',
        name: 'home',
        component: DefaultLayout,
        withSubDomain: true,
        routes: [
            {
                path: staticPaths.myActivities.pathname,
                name: 'my-activities',
                component: createRequiredLogin()(
                    nest(
                        withProps(() => ({
                            renderHeader: NullAsDefault,
                            renderMenu: NullAsDefault,
                            renderRight: NullAsDefault,
                        }))(ContentLayout),
                        MyActivities
                    )
                ),
                exact: true,
            },
            {
                path: '/my-bookmarks',
                name: 'my-bookmarks',
                component: createRequiredLogin()(
                    nest(
                        withProps(() => ({
                            renderHeader: NullAsDefault,
                            renderMenu: NullAsDefault,
                            renderRight: NullAsDefault,
                        }))(ContentLayout),
                        MyBookmarks
                    )
                ),
                exact: true,
            },
            {
                path: '/classroom/:id',
                name: 'course class',
                component: createLazyComponent(() =>
                    import('views/AppLocals/Course/CourseClass/CourseClassPage')
                ),
                // exact: true,
            },
            {
                path: '/examination/:id',
                name: 'examination',
                component: createLazyComponent(() =>
                    import('views/AppLocals/Exam/components/ExamPreps')
                ),
                exact: true,
            },
            {
                path: '/examination/:id/start',
                name: 'examination',
                component: withProps({
                    Component: createLazyComponent(() =>
                        import('views/AppLocals/Exam/components/ExamStart')
                    ),
                })(NotRequiredLoginModal),
                exact: true,
            },
            {
                path: '/examination-paper/:id',
                name: 'examination-paper',
                component: Exam,
                exact: true,
            },


            {
                path: '/games/:id/play',
                name: 'game-play',
                component: createLazyComponent(() =>
                    import('views/AppLocals/Game/containers/GamePlayPage')
                ),
                exact: true,
            },
            {
                path: '/games/:id',
                name: 'game',
                component: createLazyComponent(() =>
                    import('views/AppLocals/Game/containers/GameDetailPage')
                ),
                exact: true,
            },
            {
                path: '/course-class-exam/:id',
                name: 'course-class-exam',
                component: CourseClassExamPage,
                exact: true,
            },
            {
                path: '/course-class-exam-attempt/:id',
                name: 'course-class-exam-attempt',
                component: CourseClassExamAttempt,
                exact: true,
            },

            {
                path: '/account/settings',
                name: 'account settings',
                component: createRequiredLogin(ModalLogin)(
                    compose(
                        fromRenderProps(NavigationContext.Consumer, ({handleGoBack}) => ({
                            onCancel: handleGoBack,
                        })),
                        fromRenderProps(LoginContext.Consumer, (login) => ({
                            navTitle: getTitle(login),
                        })),
                        withProps(() => ({
                            maskClosable: false,
                        }))
                    )(
                        nest(
                            Pure,
                            withProps(() => ({
                                // Trang cài đặt chính chủ — tiêu đề cố định "Cài đặt tài khoản" thay vì
                                // tên chính người dùng (navTitle) để không đọc như đang xem hồ sơ người khác.
                                renderHeader: () => (
                                    <Translate>
                                        {(t) => <PageHeader title={t('account settings')}/>}
                                    </Translate>
                                ),
                                renderMenu: NullAsDefault,
                                renderRight: NullAsDefault,
                            }))(ContentLayout),
                            AccountSettings
                        )
                    )
                ),
            },
            {
                path: '/channel/:id/settings',
                name: 'channel setting',
                withSubDomain: true,
                component: createRequiredLogin(ModalLogin)(
                    withProps((props) => {
                        const id = get(props, 'match.params.id')
                        return {
                            id,
                            navTitle: String(id),
                        }
                    })(
                        nest(
                            Pure,
                            compose(
                                withTranslate,
                                withProps(({translate: t, navTitle}) => ({
                                    renderHeader: () => <PageHeader title={t("channel settings")}/>,
                                    renderMenu: NullAsDefault,
                                    renderRight: NullAsDefault,
                                })))
                            (ContentLayout),
                            ChannelSetting
                        )
                    )
                ),
            },
            {
                key: 'codi-doc-by-id',
                name: 'codi-doc-by-id',
                path: gPaths.book,
                exact: true,
                component: Codi,
            },
            {
                key: 'profile-by-id',
                name: 'profile-by-id',
                path: gPaths.profile,
                exact: true,
                component: Profile,
            },
            {
                key: 'word-of-god',
                name: 'word-of-god',
                path: gPaths.wog,
                exact: true,
                component: WoG,
            },
            {
                key: 'music-doc-by-id',
                name: 'music-doc-by-id',
                path: gPaths.music,
                exact: true,
                component: Music,
            },
            {
                key: 'catholic-household-book',
                name: 'catholic-household-book',
                path: gPaths.catholicHouseholdBook,
                exact: true,
                component: CatholicHousehold,
            },
            {
                key: 'family-book',
                name: 'family-book',
                path: gPaths.familyBook,
                exact: true,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    FamilyBookDetail
                ),
            },
            {
                key: 'church',
                name: 'church',
                path: gPaths.churchDetail,
                exact: true,
                component: ChurchDetail,
            },
            {
                key: 'topic',
                name: 'topic',
                path: '/t/:id',
                withSubDomain: true,
                component: ({match, ...props}) => {
                    const {id} = match.params
                    if (isEmpty(id)) {
                        return <Redirect to={documentModel.getLinkToDocuments()}/>
                    }
                    return <Topic {...{match, ...props}} />
                },
            },
            {
                key: 'redirect-to-topic',
                name: 'redirect-to-topic',
                path: '/t',
                exact: true,
                component: () => {
                    return <Redirect to={documentModel.getLinkToDocuments()}/>
                },
            },
            {
                key: 'welcome',
                name: 'welcome',
                path: '/welcome',
                exact: true,
                component: createRequiredNonLogin(() => (
                    <Redirect to={staticPaths.home}/>
                ))(LandingPage),
            },
            {
                name: 'helps',
                path: '/helps/:id',
                component: DocumentEditor,
            },
            {
                name: 'helps',
                path: '/helps',
                component: DocumentEditor,
            },
            {
                path: '/account',
                name: 'account',
                component: createRequiredLogin(ModalLogin)(Account),
            },
            {
                path: '/menu',
                name: 'menu',
                withSubDomain: true,
                component: createRequiredLogin(
                    withProps({
                        to: '/login',
                        state: {isModal: true},
                    })(Redirect)
                )(Menu),
                exact: true,
            },
            {
                path: '/forgot-password',
                name: 'forgot password',
                component: ForgetPassword,
                exact: true,
                meta: {
                    validate: [REQUIRED_NON_LOGIN],
                },
            },
            {
                path: '/user/account',
                name: 'account center',
                component: PageDetail,
                exact: true,
                meta: {
                    validate: [REQUIRED_LOGIN],
                },
            },
            {
                path: '/discovery',
                name: 'discovery',
                exact: true,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DiscoveryPage
                ),
            },
            {
                key: 'document',
                name: 'document',
                path: '/document/:id',
                exact: true,
                component: DocumentPost,
            },
            {
                key: 'category',
                name: 'category',
                path: '/category',
                exact: true,
                component: Category,
            },
            {
                path: '/login',
                name: 'login',
                component: Login,
                exact: true,
                withSubDomain: true,
                meta: {
                    validate: [REQUIRED_NON_LOGIN],
                },
            },
            {
                path: '/bookmark',
                name: 'bookmark',
                component: Bookmark,
                exact: true,
                meta: {
                    validate: [REQUIRED_LOGIN],
                },
            },
            {
                path: '/bookmark/:id',
                name: 'bookmark',
                component: Bookmark,
                exact: true,
                meta: {
                    validate: [REQUIRED_LOGIN],
                },
            },
            {
                key: 'menu',
                name: 'menu',
                path: '/navigationMenu',
                exact: true,
                withSubDomain: true,
                component: Navigation,
            },
            {
                path: '/channel/:id',
                name: 'channel',
                component: Channel,
                exact: true,
                withSubDomain: true,
            },
            {
                path: staticPaths.calendar.pathname,
                name: 'calendar',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    CalendarPage
                ),
                exact: true,
            },
            {
                path: staticPaths.liturgicalCalendar.pathname,
                name: 'liturgicalCalendar',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    LiturgicalCalendarPage
                ),
                exact: true,
            },
            {
                path: staticPaths.bibles.pathname,
                name: 'bibles',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    BiblePage
                ),
                exact: true,
            },
            {
                path: staticPaths.churches.pathname,
                name: 'churches',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    ChurchSearchView
                ),
                exact: true,
            },
            {
                path: staticPaths.massTimes.pathname,
                name: 'mass-times',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    MassTimesPage
                ),
                exact: true,
            },
            {
                path: staticPaths.games.pathname,
                name: 'games',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    GamesPage
                ),
                exact: true,
            },
            {
                path: staticPaths.organizations.pathname,
                name: 'organizations',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    OrganizationPage
                ),
                exact: true,
            },
            {
                path: staticPaths.products.pathname,
                name: 'products',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    ProductsPage
                ),
                exact: true,
            },
            {
                path: staticPaths.groups.pathname,
                name: 'groups',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    SpaceOrganization
                ),
                exact: true,
            },
            {
                path: staticPaths.apps.pathname,
                name: 'apps',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    SpaceWebApps
                ),
                exact: true,
            },
            {
                path: staticPaths.prayers.pathname,
                name: 'prayers',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PrayerLandingPage
                ),
                exact: true,
            },
            {
                path: staticPaths.prayerBooks.pathname,
                name: 'prayer books',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PrayerBooksLandingPage
                ),
                exact: true,
            },
            {
                // Trang riêng cho từng kinh tĩnh (Kinh Mân Côi, Kinh Giỗ...) để có URL chia sẻ + SEO
                // riêng — xem comment đầu PrayerBookDetailPage.js. Đặt sau route /prayer-books (exact)
                // ở trên nên không đụng nhau.
                path: staticPaths.prayerBookDetail.pathname,
                name: 'prayer book detail',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PrayerBookDetailPage
                ),
                exact: true,
            },
            {
                path: staticPaths.spiritualPath.pathname,
                name: 'spiritual path',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    SpiritualityPage
                ),
                exact: true,
            },
            {
                path: staticPaths.spiritualExamen.pathname,
                name: 'examen',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Examen
                ),
                exact: true,
            },
            {
                path: staticPaths.spiritualJournal.pathname,
                name: 'diary',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DiaryEntry
                ),
                exact: true,
            },
            {
                path: staticPaths.spiritualDiscernment.pathname,
                name: 'discernment',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Discernment
                ),
                exact: true,
            },
            {
                path: staticPaths.spiritualExercises.pathname,
                name: staticPaths.spiritualExercises.pathname,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Retreat
                ),
                exact: true,
            },
            {
                path: staticPaths.devotions.pathname,
                name: staticPaths.devotions.pathname,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Devotion
                ),
                exact: true,
            },
            {
                path: staticPaths.devotionDetail.pathname,
                name: staticPaths.devotionDetail.pathname,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DevotionDetail
                ),
                exact: true,
            },
            {
                path: staticPaths.prayerMethods.pathname,
                name: staticPaths.prayerMethods.pathname,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PrayerMethod
                ),
                exact: true,
            },
            {
                path: staticPaths.prayerMethodDetail.pathname,
                name: staticPaths.prayerMethodDetail.pathname,
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PrayerMethodDetail
                ),
                exact: true,
            },
            {
                path: staticPaths.dioceses.pathname,
                name: 'dioceses',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DioceseParishesPage
                ),
                exact: true,
            },
            {
                path: staticPaths.religiousOrder.pathname,
                name: 'religious orders',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    ReligiousOrderPage
                ),
                exact: true,
            },
            {
                path: staticPaths.yellowPages.pathname,
                name: 'yellow pages',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    YellowPages
                ),
                exact: true,
            },
            {
                path: staticPaths.missals.pathname,
                name: 'missals',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Missals
                ),
                exact: true,
            },
            {
                key: 'missal-by-id',
                name: 'missal-by-id',
                path: gPaths.missal,
                exact: true,
                component: MissalV2,
            },
            {
                key: 'missal-v1-by-id',
                name: 'missal-v1-by-id',
                path: gPaths.missalV1,
                exact: true,
                component: Missal,
            },
            {
                key: 'missal-by-page',
                name: 'missal-by-page',
                path: gPaths.missalPage,
                exact: true,
                component: MissalPage,
            },
            {
                key: 'missal-page-edit',
                name: 'missal-page-edit',
                path: gPaths.missalPageEdit,
                exact: true,
                component: MissalPageEditor,
            },
            // {
            //     key: 'missal-version-by-id',
            //     name: 'missal-version-by-id',
            //     path: gPaths.missalVersion,
            //     exact: true,
            //     component: MissalVersion,
            // },
            {
                path: staticPaths.musics.pathname,
                name: 'musics',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    MusicPage
                ),
                exact: true,
            },
            {
                path: staticPaths.hymns.pathname,
                name: 'songs',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    SongsPage
                ),
                exact: true,
            },
            {
                path: staticPaths.familyBooks.pathname,
                name: 'family-books',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    FamilyBooks
                ),
                exact: true,
            },
            {
                path: staticPaths.accessPortal.pathname,
                name: 'access-portal',
                // Bắt buộc đăng nhập (checkAccess() backend cần user_login) - fallback ModalLogin
                // mặc định (giống các route createRequiredLogin() khác trong file này).
                component: createRequiredLogin()(
                    nest(
                        withProps(() => ({
                            renderHeader: NullAsDefault,
                            renderMenu: NullAsDefault,
                            renderRight: NullAsDefault,
                        }))(ContentLayout),
                        AccessPortalPage
                    )
                ),
                exact: true,
            },
            {
                path: staticPaths.asks.pathname,
                name: 'asks',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    AskPage
                ),
                exact: true,
            },
            {
                path: staticPaths.discussions.pathname,
                name: 'discussions',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DiscussionsPage
                ),
                exact: true,
            },

            {
                path: staticPaths.examinations.pathname,
                name: 'examinations',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    ExaminationPage
                ),
                exact: true,
            },
            {
                path: staticPaths.news.pathname,
                name: 'catholic_newspage',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    CatholicNewsPage
                ),
                exact: true,
            },
            {
                path: '/news?mode=article',
                name: 'catholic_newspage_article',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    CatholicNewsPage
                ),
                exact: true,
            },
            {
                path: '/news?mode=channel',
                name: 'catholic_newspage_channel',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    CatholicNewsPage
                ),
                exact: true,
            },
            {
                path: staticPaths.profiles.pathname,
                name: 'profiles',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    ProfilePage
                ),
                exact: true,
            },
            {
                path: staticPaths.ecclesiasticDocument.pathname,
                name: 'ecclesiastic',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    EcclesiasticPage
                ),
                exact: true,
            },
            {
                path: staticPaths.documentLibrary.pathname,
                name: 'document-library',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DocumentsPage
                ),
                exact: true,
            },
            {
                path: staticPaths.definitions.pathname,
                name: 'definitions',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    DefinitionPage
                ),
                exact: true,
            },
            {
                key: 'definition-by-id',
                name: 'definition-by-id',
                path: gPaths.definition,
                exact: true,
                component: DefinitionSinglePage,
            },
            {
                key: 'dictionary-by-id',
                name: 'dictionary-by-id',
                path: gPaths.dictionary,
                exact: true,
                component: DictionarySinglePage,
            },
            {
                path: staticPaths.edu.pathname,
                name: 'courses',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    EducationPage
                ),
                exact: true,
            },
            {
                path: staticPaths.catholicHouseholds.pathname,
                name: 'catholic-households',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    CatholicHouseholdPage
                ),
                exact: true,
            },
            {
                path: staticPaths.liturgies.pathname,
                name: 'liturgies',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    LiturgiesPage
                ),
                exact: true,
            },
            {
                path: staticPaths.feedbacks.pathname,
                name: 'feedbacks',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    Feedbacks
                ),
                exact: true,
            },
            {
                path: staticPaths.turnToChrist.pathname,
                name: 'turnToChrist',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    TurnToChristPage
                ),
                exact: true,
            },
            {
                path: staticPaths.evangelization.pathname,
                name: 'evangelization',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    EvangelizationPage
                ),
                exact: true,
            },
            {
                path: staticPaths.pilgrimage.pathname,
                name: 'pilgrimage',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    PilgrimagePage
                ),
                exact: true,
            },
            {
                path: staticPaths.feedbackRequests.pathname,
                name: 'feedbackRequests',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    FeedbackRequests
                ),
                exact: true,
            },
            {
                path: staticPaths.liturgical.pathname,
                name: 'liturgical',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    LiturgicalPage
                ),
                exact: true,
            },
            {
                path: '/event-checkin/:event_id/:event_location_id/invites',
                name: 'event_location_checkins',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    createLazyComponent(() => import("../views/AppLocals/Event/EventCheckinInvite"))
                ),
                exact: true,
            },
            {
                path: '/article/new',
                name: 'new-article',
                component: createRequiredLogin()((props) => (
                    <CreateNewArticle
                        {...props}
                        action={CRUD.CREATE}
                    />
                )),
                exact: true,
            },
            {
                path: '/article/:id/edit',
                key: 'edit-article',
                component: createRequiredLogin()(CreateNewArticle),
                exact: true,
            },

            {
                path: '/notifications',
                name: 'notifications',
                component: createRequiredLogin(ModalLogin)(Notification),
                exact: true,
            },
            {
                path: '/news/article/:id',
                name: 'news',
                component: createLazyComponent(() => import('../views/Article')),
                withSubDomain: true,
            },
            {
                path: '/news/:type/:id',
                name: 'post',
                component: Feed,
                exact: true,
                withSubDomain: true,
            },
            {
                path: '/success-sign-up/redirect',
                key: 'success-sign-up-redirect',
                name: 'pageRedirect',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    compose(
                        withTranslate,
                        mapProps(({translate: t, ...props}) => {
                            return {
                                title: t('Successfully Sign Up'),
                                description: (
                                    <div className="text-center px-3">
                                        {t('Thank you for registering, Website will redirect to login page')}
                                    </div>
                                ),
                                redirectPath: '/login',
                                redirectLabel: 'login',
                                ...props,
                            }
                        }),
                        pure
                    )(RedirectPage)
                ),
            },
            {
                path: '/404',
                key: '404',
                name: 'pageNotFound',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    NoFoundPage
                ),
            },
            {
                ...MainPage,
            },
            {
                // must be at bottom
                path: '/',
                name: 'NoFoundPage',
                component: nest(
                    withProps(() => ({
                        renderHeader: NullAsDefault,
                        renderMenu: NullAsDefault,
                        renderRight: NullAsDefault,
                    }))(ContentLayout),
                    NoFoundPage
                ),
            },
        ],
    },
]
const PageModal = ({children, ...props}) => (
    <NavigationContext.Consumer>
        {({handleGoBack}) => (
            <Modal
                open="true"
                footer={null}
                header={
                    <HeaderButton
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                        }}
                        onClick={handleGoBack}>
                        <Icon
                            style={{
                                fontWeight: 700,
                                fontSize: '1.2em',
                            }}
                            component={MdClose}
                        />
                    </HeaderButton>
                }
                onCancel={handleGoBack}
                {...props}>
                <div className="mx-auto flex flex-1 flex-col">{children}</div>
            </Modal>
        )}
    </NavigationContext.Consumer>
)

export const modalRoutesConfig = [
    {
        path: '/login',
        name: 'login',
        withSubDomain: true,
        component: createRequiredNonLogin(() => {
            const history = useHistory()
            const location = useLocation()
            const redirectUrl = get(location, 'state.state.from')
            if (!!redirectUrl) {
                history.push(redirectUrl)
            }
            const {handleGoBack} = useContext(NavigationContext)
            useEffect(() => {
                if (!redirectUrl) {
                    handleGoBack()
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [handleGoBack])

            return null
        })(ModalLogin),
        exact: true,
    },
    {
        path: '/register',
        name: 'register',
        component: createRequiredNonLogin(() => {
            const {handleGoBack} = useContext(NavigationContext)
            useEffect(() => {
                handleGoBack()
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [handleGoBack])
            return null
        })(ModalSignUp),
        exact: true,
    },
    {
        key: 'logout',
        name: 'logout',
        path: '/logout',
        withSubDomain: true,
        exact: true,
        component: nest(PageModal, Logout),
    },
    {
        path: '/forgot-password',
        name: 'forgotpass',
        component: createRequiredNonLogin(() => {
            const {handleGoBack} = useContext(NavigationContext)
            useEffect(() => {
                handleGoBack()
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [handleGoBack])
            return null
        })(ModalForgetPassword),
        exact: true,
    },
    {
        path: '/create-channel',
        name: 'create channel',
        component: createRequiredLogin(ModalLogin)((props) => {
            const {willRedirect = true} = props.location?.state ?? {}
            return (
                <LoginContext.Consumer>
                    {(login) => (
                        <ServerContainer item={login}>
                            <NavigationContext.Consumer>
                                {({history}) => (
                                    <CreateChannelFormModal
                                        {...props}
                                        onSuccess={
                                            willRedirect
                                                ? props.onSuccess
                                                : (__, onCancel = NullAsDefault) => {
                                                    onCancel()
                                                    history.push({
                                                        state: {
                                                            ...(history?.location?.state ?? {}),
                                                            refreshToken: Date.now(),
                                                        },
                                                    })
                                                }
                                        }
                                    />
                                )}
                            </NavigationContext.Consumer>
                        </ServerContainer>
                    )}
                </LoginContext.Consumer>
            )
        }),
    },
    {
        path: '/create-event',
        name: 'create event',
        component: createRequiredLogin(ModalLogin)((props) => (
            <LoginContext.Consumer>
                {(login) => (
                    <ServerContainer item={login}>
                        <CreateEventFormModal {...props} />
                    </ServerContainer>
                )}
            </LoginContext.Consumer>
        )),
    },
    ...gConfigs.gModalRoutes,
    {
        path: '/createPoll',
        name: 'Create Poll',
        title: 'create poll',
        component: createRequiredLogin(ModalLogin)(nest(PageModal, CreatePoll)),
        exact: true,
    },
    {
        path: '/quickLink',
        name: 'quick link',
        component: createRequiredLogin(ModalLogin)(EnhancedQuickLink),
        exact: true,
    },
    {
        path: '/quickLink/:id/settings',
        name: 'setting quick link',
        component: createRequiredLogin(ModalLogin)(EnhancedQuickLinkSetting),
        exact: true,
    },
    {
        path: '/navigationMenu',
        name: 'menu',
        component: nest(PageModal, Navigation),
        exact: true,
    },
    {
        path: '/news/:type/:id/edit',
        name: 'post',
        component: createRequiredLogin()(
            mapProps((props) => ({
                id: get(props, 'match.params.id'),
                type: get(props, 'match.params.type'),
            }))(FeedSetting)
        ),
        exact: true,
        withSubDomain: true,
    },
    {
        path: '/search',
        name: 'search',
        component: compose(
            fromRenderProps(NavigationContext.Consumer, ({handleGoBack}) => ({
                onCancel: handleGoBack,
            })),
            withProps((props) => ({}))
        )(Search),
        exact: true,
    },
    // {
    //   path: '/test-screen',
    //   name: 'test screen',
    //   component: compose(
    //     fromRenderProps(NavigationContext.Consumer, ({ handleGoBack }) => ({
    //       onCancel: handleGoBack,
    //     }))
    //   )(TestScreen),
    //   exact: true,
    // },
]
